import { Icon } from "@nju/icons";
import { Button, Panel, Separator, Text } from "@nju/ui";

interface IConfirmDisagreementSuccessProps {
  refresh: () => void;
}

export function ConfirmDisagreementSuccess({
  refresh,
}: IConfirmDisagreementSuccessProps) {
  return (
    <Panel>
      <div className="flex flex-col items-center">
        <Text
          display="block"
          size={{
            "@onlyMobile": "l",
            "@fromTablet": "keyM",
          }}
          weight="bold"
        >
          zmiany zostały zapisane
        </Text>
        <Separator size="s" tone="invisible" />
        <Icon
          className="w-12 h-12 from-tablet:w-[90px] from-tablet:h-[90px]"
          name="check-circle-incircle"
        />
        <Separator size="s" tone="invisible" />
        <Button
          display={{
            "@onlyMobile": "block",
          }}
          onPress={refresh}
          size={{ "@onlyMobile": "s" }}
        >
          ok
        </Button>
      </div>
    </Panel>
  );
}
